import { i18n } from '@/plugins/vue-i18n'

export interface IFacturaEState {
  invoiceId: string | null
  bankdata: IBankdata[]
  paymentType: string | undefined
  professionalList: IProfessional[]
  selectedProfessional: IProfessional | null
  amendReason: AmendItemType[]
  amendCodeTax: AmendItemType[]
}

export interface IFacturaEForUpdate {
  invoiceId: number
  invoicePaid: boolean
  portalPublish: boolean
}

export interface IBankdraftForUpdate {
  invoiceId: number
  bankdraftId: number
  bankdraftPaid: boolean
  bankdraftPaidDate: string
}

export interface IBankdata{
  id: string
  idContact: string | null
  idProfessional: string | null
  main: string
  bank: string
  accountNumber: string
}

export interface IProfessional {
  id: string
  name: string
  facturaEActive: boolean
  taxNetwork: TaxNetworkEnum | null
}

export enum TaxNetworkEnum {
  FACTURA_E = 'Factura-e',
  TICKET_BAI = 'TicketBAI'
}

export enum BankdataTypeEnum {
  TRANSFER = 'transfer',
  DIRECT_DEBIT = 'direct-devit'
}

export enum FacturaEStatusEnum {
  DRAFT = 'draft',
  BLOCKED = 'blocked',
  SENT = 'sent',
  ERROR = 'error',
  ACCEPTED = 'accepted',
  REFUSED = 'refused'
}

export enum BankdataIdEnum {
  DIRECT_DEBIT_ID = '58',
  TRANSFER_ID = '4',
}

export const paymentTypeWithBankdata: { [id in BankdataIdEnum]: BankdataTypeEnum | undefined } = {
  [BankdataIdEnum.TRANSFER_ID]: BankdataTypeEnum.TRANSFER,
  [BankdataIdEnum.DIRECT_DEBIT_ID]: BankdataTypeEnum.DIRECT_DEBIT,
}

export const facturaEStatusDisplay: { [key in FacturaEStatusEnum]: string | undefined } = {
  [FacturaEStatusEnum.DRAFT]: i18n.t('grid.columns.tags.draft').toString(),
  [FacturaEStatusEnum.BLOCKED]: i18n.t('grid.columns.tags.blocked').toString(),
  [FacturaEStatusEnum.SENT]: i18n.t('grid.columns.tags.sent').toString(),
  [FacturaEStatusEnum.ERROR]: i18n.t('grid.columns.tags.error').toString(),
  [FacturaEStatusEnum.ACCEPTED]: i18n.t('grid.columns.tags.accepted').toString(),
  [FacturaEStatusEnum.REFUSED]: i18n.t('grid.columns.tags.refused').toString()
}

export type AmendItemType = {
  id: string;
  name: string;
};

export const amendReason: AmendItemType[] = [
  { id: '01', name: '01: Número de factura' },
  { id: '02', name: '02: Número de serie de la factura' },
  { id: '03', name: '03: Fecha de emisión' },
  { id: '04', name: '04: Nombre y apellidos / Razón social Emisor (Remitente)' },
  { id: '05', name: '05: Nombre y apellidos / Razón social Receptor' },
  { id: '06', name: '06: Número de identificación fiscal del emisor' },
  { id: '07', name: '07: Número de identificación fiscal del receptor' },
  { id: '08', name: '08: Dirección del emisor' },
  { id: '09', name: '09: Dirección del receptor' },
  { id: '10', name: '10: Línea del artículo' },
  { id: '11', name: '11: Tipo impositivo aplicable' },
  { id: '12', name: '12: Importe del impuesto aplicable' },
  { id: '13', name: '13: Fecha/Período aplicable' },
  { id: '14', name: '14: Clase de factura' },
  { id: '15', name: '15: Literales legales' },
  { id: '16', name: '16: Base imponible' },
  { id: '80', name: '80: Cálculo de los impuestos repercutidos' },
  { id: '81', name: '81: Cálculo de los impuestos soportados' },
  { id: '82', name: '82: Base imponible modificada por devolución de envases y embalajes' },
  { id: '83', name: '83: Base Imponible modificada por descuentos y bonificaciones' },
  { id: '84', name: '84: Base imponible modificada por sentencia judicial firme o resolución administrativa' },
  { id: '85',
    name: '85: Base Imponible modificada por salidas impagadas cuando existe sentencia de apertura de concurso de acreedores'
  },
]

export const amendCodeTax: AmendItemType[] = [
  { id: 'R1', name: 'R1: Error fundado en la ley y Art. 80 Primero, Segundo y Sexto del Reglamento Foral del IVA' },
  { id: 'R2', name: 'R2: Artículo 80 Tercero del Reglamento Foral del IVA' },
  { id: 'R3', name: 'R3: Art. 80 Cuarto del Reglamento Foral del IVA' },
  { id: 'R4', name: 'R4: Resto' },
  { id: 'R5', name: 'R5: Factura rectificativa en facturas simplificadas' }
]

export const facturaEIssuedStatus: FacturaEStatusEnum[] = [
  FacturaEStatusEnum.BLOCKED,
  FacturaEStatusEnum.ACCEPTED,
  FacturaEStatusEnum.SENT,
  FacturaEStatusEnum.REFUSED
]

export const facturaEMutationTypes = {
  SET_BANKDATA: 'SET_BANKDATA',
  SET_INVOICE_ID: 'SET_INVOICE_ID',
  SET_PAYMENT_TYPE: 'SET_PAYMENT_TYPE',
  SET_PROFESSIONAL_LIST: 'SET_PROFESSIONAL_LIST',
  SET_SELECTED_PROFESSIONAL: 'SET_SELECTED_PROFESSIONAL',
  RESET_PROFESSIONAL: 'RESET_PROFESSIONAL',
}

export const FacturaEUserMessages = {
  'The template file does not exist': i18n.t('components.dialog.facturae_document_error').toString(),
  'The template file cannot be read': i18n.t('components.dialog.facturae_document_error').toString(),
  'Error reading template file': i18n.t('components.dialog.facturae_document_error').toString(),
}
